import React, { Fragment, useContext, useRef, useState } from "react";
import { Fade, Zoom } from "react-awesome-reveal";
import { Helmet } from "react-helmet-async";
import { Link, useNavigate } from "react-router-dom";
// import { BookingForm } from "../components/BookingForm";
// import { BookingFormGroup } from "../components/cruiseBooking/BookingFormGroup";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
// import "swiper/swiper-bundle.min.css";
import { DateRangePicker } from "rsuite";
import "rsuite/dist/rsuite.min.css";
import { format } from "date-fns";
import Rating from "@mui/material/Rating";
import Box from "@mui/material/Box";
import StarIcon from "@mui/icons-material/Star";
import { colors, Slider, Tooltip } from "@mui/material";
// import useGoogleMapsScript from "../components/useGoogleMapsScript";
import { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faLocationDot,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { fetchThanksData } from "../data/groupBooking/getThanksPageSlice";
import Loader from "../Loader";

const BookingConfirmation = () => {
  const navigate = useNavigate();

  const orderConfirmationNumber = localStorage.getItem(
    "orderConfirmationNumber"
  );
  const dispatch = useDispatch();
  const { thanksData, loadings, error } = useSelector(
    (state) => state.thanksData
  );
  useEffect(() => {
    if (orderConfirmationNumber) {
      dispatch(fetchThanksData(orderConfirmationNumber))
        .unwrap()
        .catch((error) => {
          console.error("Failed to refetch cruise list:", error);
        });
    }
  }, [dispatch, orderConfirmationNumber]);
  // useEffect(() => {

  //     const script1 = document.createElement("script");
  //     script1.async = true;
  //     script1.src = "https://www.googletagmanager.com/gtag/js?id=GTM-5PWCGC45";
  //     document.head.appendChild(script1);

  //     const script2 = document.createElement("script");
  //     script2.innerHTML = `
  //     window.dataLayer = window.dataLayer || [];
  //     function gtag(){dataLayer.push(arguments);}
  //     gtag('js', new Date());
  //     gtag('config', 'GTM-5PWCGC45', { 'debug_mode': true });
  //   `;
  //     document.head.appendChild(script2);

  //     // Add the purchase event script
  //     const script3 = document.createElement("script");
  //     script3.innerHTML = `
  //     gtag('event', 'purchase', {
  //       'transaction_id': '${thanksData?.gtm?.transaction_id}',
  //                   'affiliation': '${thanksData?.gtm?.affiliation}',
  //                   'value':  ${thanksData?.gtm?.value},
  //                   'currency': '${thanksData?.gtm?.currency}',
  //                   'tax': ${thanksData?.gtm?.tax},
  //                   'shipping':  ${thanksData?.gtm?.shipping},
  //      'items': [
  //                       {
  //                           'item_id': '${thanksData?.gtm?.items?.map(
  //                             (i) => i.item_id
  //                           )}',
  //                           'item_name':' ${thanksData?.gtm?.items?.map(
  //                             (i) => i.item_name
  //                           )}',
  //                           'item_brand': '${thanksData?.gtm?.items?.map(
  //                             (i) => i.item_brand
  //                           )}',
  //                           'item_category':'${thanksData?.gtm?.items?.map(
  //                             (i) => i.item_category
  //                           )}',
  //                           'item_variant': '${thanksData?.gtm?.items?.map(
  //                             (i) => i.item_variant
  //                           )}',
  //                           'affiliation': '${thanksData?.gtm?.items?.map(
  //                             (i) => i.affiliation
  //                           )}',
  //                           'discount': ${thanksData?.gtm?.items?.map(
  //                             (i) => i.discount
  //                           )},
  //                           'quantity': ${thanksData?.gtm?.items?.map(
  //                             (i) => i.quantity
  //                           )},
  //                           'price': ${thanksData?.gtm?.items?.map(
  //                             (i) => i.price
  //                           )}
  //                       }
  //                   ]
  //     });
  //   `;
  //     document.body.appendChild(script3);

  //     return () => {
  //       document.head.removeChild(script1);
  //       document.head.removeChild(script2);
  //       document.body.removeChild(script3);
  //     };

  // }, [loadings, thanksData?.gtm]);

  const [gtmLoaded, setGtmLoaded] = useState(false);

  useEffect(() => {
    const checkGtm = setInterval(() => {
      if (window.dataLayer) {
        setGtmLoaded(true);
        clearInterval(checkGtm);
      }
    }, 500);

    return () => clearInterval(checkGtm);
  }, []);

  useEffect(() => {
    if (!gtmLoaded || !thanksData || !thanksData.gtm) return;

    window.dataLayer.push({
      event: "purchase",
      debug_mode: true,
      transaction_id: thanksData.gtm.transaction_id,
      affiliation: thanksData.gtm.affiliation,
      value: thanksData.gtm.value,
      currency: thanksData.gtm.currency,
      tax: thanksData.gtm.tax,
      shipping: thanksData.gtm.shipping,
      items: thanksData.gtm.items.map((item) => ({
        item_id: item.item_id,
        item_name: item.item_name,
        item_brand: item.item_brand,
        item_category: item.item_category,
        item_variant: item.item_variant,
        affiliation: item.affiliation,
        discount: item.discount,
        quantity: item.quantity,
        price: item.price,
      })),
    });
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "purchase",
      ecommerce: {
        transaction_id: "12345ABC", // يجب استبداله بالـ transaction_id الحقيقي
        affiliation: "My Store",
        value: 100.5,
        currency: "USD",
        tax: 5.0,
        shipping: 10.0,
        items: [
          {
            item_id: "P12345",
            item_name: "Laptop",
            item_brand: "BrandX",
            item_category: "Electronics",
            item_variant: "16GB RAM",
            quantity: 1,
            price: 100.5,
          },
        ],
      },
    });
  }, [gtmLoaded, thanksData]);
  return (
    <>
      {loadings ? (
        <Loader />
      ) : error ? (
        error
      ) : (
        <Fragment>
          <Helmet>
            <title>Booking Confirmation</title>{" "}
            <style>
              {`
            .header .header-menu .menu li a{
            color:#051036;
            }
            .header .header-menu .menu .subnav>li>a {
            color:#051036 !important;
            }
            .is-sticky.bg-dark-1{
            background-color:#fff !important;
            }
            // .is-sticky .menu li a{
            // color:#fff !important;
            // }
            .ratio-15\:9::before{
            padding-bottom:0 !important;}
            `}
            </style>
          </Helmet>
          {/*banner */}
          <section className="row d-flex items-center  mt-60  ">
            <div className="  mt-40 py-40 bg-light-2 border-top-light">
              <div className="container d-flex justify-content-between m-auto px-1    y-gap-30 items-center ">
                <div className="col-auto pe-1">
                  <Tooltip arrow title="Return To Choose Cruise">
                    <div
                      className="d-flex items-center"
                      // onClick={() => navigate(-4)}
                      // style={{ cursor: "pointer" }}
                      onMouseEnter={(e) => {
                        e.target.style.color = "#1976d2";
                      }}
                    >
                      <div className="size-40 rounded-full flex-center bg-blue-1">
                        <i className="icon-check text-16 text-white"></i>
                      </div>
                      <div className="text-18 text-blue-1 fw-500 ml-10">
                        Choose Cruise
                      </div>
                    </div>
                  </Tooltip>
                </div>{" "}
                <div className="col px-1">
                  <div className="w-full h-1 border-blue-1 bg-border"></div>
                </div>
                <div className="col-auto  px-1">
                  <Tooltip arrow title="Return To Choose Cabin">
                    <div
                      className="d-flex items-center"
                      // onClick={() => navigate(-3)}
                      // style={{ cursor: "pointer" }}
                      onMouseEnter={(e) => {
                        e.target.style.color = "#1976d2";
                      }}
                    >
                      <div className="size-40 rounded-full flex-center bg-blue-1">
                        <i className="icon-check text-16 text-white"></i>
                      </div>
                      <div className="text-18 text-blue-1 fw-500 ml-10">
                        Choose Cabin
                      </div>
                    </div>
                  </Tooltip>
                </div>
                <div className="col px-1">
                  <div className="w-full h-1 border-blue-1 bg-border"></div>
                </div>
                {thanksData?.response?.extras?.length > 0 && (
                  <Fragment>
                    <div className="col-auto  px-1">
                      <Tooltip arrow title="Return To Select Extras">
                        <div
                          className="d-flex items-center"
                          // onClick={() => navigate(-2)}
                          // style={{ cursor: "pointer" }}
                          onMouseEnter={(e) => {
                            e.target.style.color = "#1976d2";
                          }}
                        >
                          <div className="size-40 rounded-full flex-center bg-blue-1 text-white">
                            <i
                              className="icon-check text-16 text-white"
                              style={{ color: "#fff" }}
                            ></i>
                          </div>
                          <div className="text-18 text-blue-1 fw-500 ml-10">
                            Add Extra
                          </div>
                        </div>
                      </Tooltip>
                    </div>
                    <div className="col px-1">
                      <div className="w-full h-1 border-blue-1 bg-border"></div>
                    </div>
                  </Fragment>
                )}
                <div className="col-auto px-1">
                  <div className="d-flex items-center">
                    <div className="size-40 rounded-full flex-center bg-blue-1">
                      <i className="icon-check text-16 text-white"></i>
                    </div>
                    <div className="text-18 text-blue-1 fw-500 ml-10">
                      Checkout{" "}
                    </div>
                  </div>
                </div>
                <div className="col px-1">
                  <div className="w-full h-1 border-blue-1 bg-border"></div>
                </div>
                <div className="col-auto px-1">
                  <div className="d-flex items-center">
                    <div className="size-40 text-16 text-white rounded-full flex-center bg-blue-1">
                      {thanksData.extras?.length > 0 ? "5" : "4"}
                    </div>
                    <div className="text-18 text-center text-blue-1 fw-500 ml-10">
                      Booking Completed!
                      <br />
                      (Thank You)
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className=" layout-pb-md">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  {thanksData?.response?.paymentStatus == "SUCCESS" ? (
                    <div className="d-flex flex-column items-center mt-60 lg:md-40 sm:mt-24">
                      <div className="size-80 flex-center text-white rounded-full flex-center bg-blue-1">
                        <i className="icon-check text-30 text-white"></i>
                      </div>

                      <div className="text-30 lh-1 fw-600 mt-20  text-main">
                        Payment Successfully Paid!{" "}
                      </div>
                      <div className="text-15 text-light-1 mt-10 col-lg-6 text-center">
                        Thank you for your payment. Your transaction has been
                        successfully completed. Booking details has been sent
                        to:{" "}
                        <span className="text-primary">
                          {thanksData?.response?.customerEmailAddress}
                        </span>{" "}
                      </div>
                    </div>
                  ) : null}

                  <div className="border-type-1 rounded-8 px-50 py-35 mt-40">
                    <div className="row justify-content-between text-center">
                      <div className="col-lg-3 col-md-6">
                        <div className="text-15 lh-12 text-main">
                          Order Number{" "}
                        </div>
                        <div className="text-15 lh-12 fw-500 text-blue-1 mt-10 ">
                          {thanksData?.response?.orderConfirmationNumber}{" "}
                        </div>
                      </div>

                      <div className="col-lg-3 col-md-6">
                        <div className="text-15 lh-12 text-main">
                          Order Date{" "}
                        </div>
                        <div className="text-15 lh-12 fw-500 text-blue-1 mt-10">
                          {thanksData?.response?.orderDateTime}{" "}
                        </div>
                      </div>

                      <div className="col-lg-3 col-md-6">
                        <div className="text-15 lh-12 text-main">Total </div>
                        <div className="text-15 lh-12 fw-500 text-blue-1 mt-10">
                          ${thanksData?.response?.totalPrice}
                        </div>
                      </div>

                      <div className="col-lg-3 col-md-6">
                        <div className="text-15 lh-12 text-main">
                          Payment Status{" "}
                        </div>
                        <div className="text-15 lh-12 fw-500 text-blue-1 mt-10">
                          {thanksData?.response?.paymentStatus}{" "}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="border-light rounded-8 px-50 py-40 mt-40">
                    <h4 className="text-20 fw-500 mb-30">Your Information </h4>

                    <div className="row y-gap-10 mb-20">
                      <div className="col-12">
                        <div className="d-flex justify-between ">
                          <div className="text-15 lh-16">Name </div>
                          <div className="text-15 lh-16 fw-500 text-blue-1">
                            {thanksData?.response?.customerName}{" "}
                          </div>
                        </div>
                      </div>

                      <div className="col-12">
                        <div className="d-flex justify-between border-top-light pt-10">
                          <div className="text-15 lh-16">Email </div>
                          <div className="text-15 lh-16 fw-500 text-blue-1">
                            {thanksData?.response?.customerEmailAddress}{" "}
                          </div>
                        </div>
                      </div>

                      <div className="col-12">
                        <div className="d-flex justify-between border-top-light pt-10">
                          <div className="text-15 lh-16">Phone </div>
                          <div className="text-15 lh-16 fw-500 text-blue-1">
                            {thanksData?.response?.customerMobile}{" "}
                          </div>
                        </div>
                      </div>

                      <div className="col-12">
                        <div className="d-flex justify-between border-top-light pt-10">
                          <div className="text-15 lh-16">Nationality </div>
                          <div className="text-15 lh-16 fw-500 text-blue-1">
                            {thanksData?.response?.nationality}
                          </div>
                        </div>
                      </div>
                      {thanksData?.response?.special_Requirement ? (
                        <div className="col-12">
                          <div className="d-flex justify-between border-top-light pt-10">
                            <div className="text-15 lh-16">
                              Special Requirement{" "}
                            </div>
                            <div className="text-15 lh-16 fw-500 text-blue-1">
                              {" "}
                              {thanksData?.response?.special_Requirement}
                            </div>
                          </div>
                        </div>
                      ) : null}
                    </div>
                    <hr />
                    <h4 className="text-20 fw-500 mb-30">
                      Booking Information{" "}
                    </h4>
                    <div className="row y-gap-10 mb-20">
                      <div className="col-12">
                        <div className="d-flex justify-between ">
                          <div className="text-15 lh-16">Cruise Name </div>
                          <div className="text-15 lh-16 fw-500 text-blue-1">
                            {thanksData?.response?.cruiseName}{" "}
                          </div>
                        </div>
                      </div>
                      {thanksData?.response?.cabins?.map((cabin, index) => (
                        <div className="col-12" key={index}>
                          <div className="d-flex justify-between border-top-light pt-10">
                            <div className="text-15 lh-16">Cabin Name </div>
                            <div className="text-15 lh-16 fw-500 text-blue-1">
                              {cabin?.cabinName}{" "}
                            </div>
                          </div>
                        </div>
                      ))}
                      {thanksData?.response?.cabins?.map((cabin, index) => (
                        <div className="col-12" key={index}>
                          <div className="d-flex justify-between border-top-light pt-10">
                            <div className="text-15 lh-16">Cabin Number </div>
                            <div className="text-15 lh-16 fw-500 text-blue-1">
                              {thanksData?.response?.cabins?.length} Cabin
                              {thanksData?.response?.cabins?.length > 1
                                ? "s"
                                : ""}
                            </div>
                          </div>
                        </div>
                      ))}
                      {thanksData?.response?.cabins?.map((cabin, index) => (
                        <div className="col-12" key={index}>
                          <div className="d-flex justify-between border-top-light pt-10">
                            <div className="text-15 lh-16">Adults Number</div>
                            <div className="text-15 lh-16 fw-500 text-blue-1">
                              {cabin.adultsNumber} Adult
                              {cabin.adultsNumber > 1 ? "s" : ""}
                            </div>
                          </div>
                        </div>
                      ))}
                      {thanksData?.response?.cabins?.map((cabin, index) => (
                        <div className="col-12" key={index}>
                          <div className="d-flex justify-between border-top-light pt-10">
                            <div className="text-15 lh-16">Child Number</div>
                            <div className="text-15 lh-16 fw-500 text-blue-1">
                              {cabin.childNumber} Child
                              {cabin.childNumber > 1 ? "s" : ""}
                            </div>
                          </div>
                        </div>
                      ))}
                      {thanksData.extras?.length > 0 ? (
                        <div className="col-12">
                          <div className="d-flex justify-between border-top-light pt-10">
                            <div className="text-15 lh-16">Extras</div>
                            <div className="text-15 text-right lh-16 fw-500 text-blue-1">
                              {thanksData?.response?.extras?.map(
                                (extra, index) => (
                                  <span key={index}>
                                    ({extra.extraName}) ${extra.priceExtraTotal}
                                    <br />
                                  </span>
                                )
                              )}
                            </div>
                          </div>
                        </div>
                      ) : null}
                    </div>
                    <hr />
                    <h4 className="text-20 fw-500 mb-30">
                      Payment Information{" "}
                    </h4>
                    <div className="row y-gap-10 mb-20">
                      <div className="col-12">
                        <div className="d-flex justify-between ">
                          <div className="text-15 lh-16">Order Number </div>
                          <div className="text-15 lh-16 fw-500 text-blue-1">
                            {thanksData?.response?.orderConfirmationNumber}{" "}
                          </div>
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="d-flex justify-between border-top-light pt-10">
                          <div className="text-15 lh-16">Order Date </div>
                          <div className="text-15 lh-16 fw-500 text-blue-1">
                            {thanksData?.response?.orderDateTime}{" "}
                          </div>
                        </div>
                      </div>

                      <div className="col-12">
                        <div className="d-flex justify-between border-top-light pt-10">
                          <div className="text-15 lh-16">Payment Status </div>
                          <div className="text-15 lh-16 fw-500 text-blue-1">
                            {thanksData?.response?.paymentStatus}{" "}
                          </div>
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="d-flex justify-between border-top-light pt-10">
                          <div className="text-15 lh-16">Taxes </div>
                          <div className="text-15 text-right lh-16 fw-500 text-blue-1">
                            {thanksData?.response?.taxes?.map((i, index) => (
                              <span key={index}>
                                ({i.basePercentage}%) ${i.priceTax}
                                <br />
                              </span>
                            ))}
                          </div>
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="d-flex justify-center align-items-center border-top-light pt-10">
                          <h3 className="text-18 lh-16 me-3">Total Price: </h3>
                          <h3 className="text-18 lh-16 fw-500 text-blue-1">
                            ${thanksData?.response?.totalPrice}{" "}
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </Fragment>
      )}
    </>
  );
};

export default BookingConfirmation;
